import { CapaDeModal } from '@/shared/components/CapaDeModal'
import { X, CheckCheck } from 'lucide-react'
import { estiloDeBoton } from '@/shared/lib/estilosDeBoton'

interface RequestFinancialDocsModalProps {
  open: boolean
  /**
   * Nombres de los documentos que se van a solicitar. Salen del back (los
   * filtra por tipo de persona), así que no se listan aquí en duro: pueden no
   * ser cuatro.
   */
  docs: string[]
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
}

const RequestFinancialDocsModal = ({
  open,
  docs,
  onClose,
  onConfirm,
  loading = false,
}: RequestFinancialDocsModalProps) => {
  if (!open) return null

  return (
    <CapaDeModal zIndex={60}>
      <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-lg p-8">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>

        <h2 className="text-2xl font-bold text-gray-900 text-center px-4">
          ¿Deseas solicitar los {docs.length} documentos financieros a
          este proveedor?
        </h2>

        <ol className="list-decimal list-inside text-gray-700 space-y-2 my-8 mx-auto w-fit">
          {docs.map((doc, i) => (
            <li key={i}>{doc}</li>
          ))}
        </ol>

        <div className="flex justify-center gap-4">
          <button
            onClick={onClose}
            disabled={loading}
            className={estiloDeBoton('secundario')}
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className={estiloDeBoton('primario')}
          >
            <CheckCheck className="w-4 h-4" />
            Solicitar
          </button>
        </div>
      </div>
    </CapaDeModal>
  )
}

export default RequestFinancialDocsModal
